"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isOutsideOfContainer = exports.computeItemHeight = void 0;
var utils_1 = require("../utils");
var computeItemHeight = function (treeId) {
    var _a;
    var firstItem = (_a = (0, utils_1.getDocument)()) === null || _a === void 0 ? void 0 : _a.querySelector("[data-rct-tree=\"".concat(treeId, "\"] [data-rct-item-container=\"true\"]"));
    if (firstItem) {
        var style = getComputedStyle(firstItem);
        // top margin flows into the bottom margin of the previous item, so ignore it
        return (firstItem.offsetHeight +
            Math.max(parseFloat(style.marginTop), parseFloat(style.marginBottom)));
    }
    return 5;
};
exports.computeItemHeight = computeItemHeight;
var isOutsideOfContainer = function (e, treeBb) {
    return e.clientX <= treeBb.left ||
        e.clientX >= treeBb.right ||
        e.clientY <= treeBb.top ||
        e.clientY >= treeBb.bottom;
};
exports.isOutsideOfContainer = isOutsideOfContainer;
